module.exports = [
	{
		"id": "SE006",
		"name": "圓凹木座",
		"type": "seat",
		"price": 3200,
		"dimension": {
			"height": 30,
			"width": 380,
			"depth": 380
		},
		"model": "SE006",
		"junctions": [
			{
				"type": "chair_leg",
				"name": "右前腳",
				"position": {
					"x": 81.03,
					"z": 81.03
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "chair_leg",
				"name": "左前腳",
				"position": {
					"x": -81.03,
					"z": 81.03
				},
				"normal": {
					"y": 1
				},
				"angle": -45
			},
			{
				"type": "chair_leg",
				"name": "左後腳",
				"position": {
					"x": -81.03,
					"z": -81.03
				},
				"normal": {
					"y": 1
				},
				"angle": -145
			},
			{
				"type": "chair_leg",
				"name": "右後腳",
				"position": {
					"x": 81.03,
					"z": -81.03
				},
				"normal": {
					"y": 1
				},
				"angle": 145
			},
			{
				"type": "center_chair_leg",
				"name": "椅腳",
				"position": {
					"x": 0,
					"z": 0
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "arm_rest",
				"name": "右扶手",
				"position": {
					"x": 115
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			},
			{
				"type": "arm_rest",
				"name": "左扶手",
				"position": {
					"x": -115
				},
				"normal": {
					"y": 1
				},
				"angle": 180
			},
			{
				"type": "back_support",
				"name": "背部支撐",
				"position": {
					"z": -145
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 300,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "SE013",
		"name": "方藤木座",
		"type": "seat",
		"price": 2800,
		"dimension": {
			"height": 30,
			"width": 370,
			"depth": 370
		},
		"model": "SE013",
		"junctions": [
			{
				"type": "chair_leg",
				"name": "右前腳",
				"position": {
					"x": 103.249,
					"z": 103.249
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "chair_leg",
				"name": "左前腳",
				"position": {
					"x": -103.249,
					"z": 103.249
				},
				"normal": {
					"y": 1
				},
				"angle": -45
			},
			{
				"type": "chair_leg",
				"name": "左後腳",
				"position": {
					"x": -103.249,
					"z": -103.249
				},
				"normal": {
					"y": 1
				},
				"angle": -145
			},
			{
				"type": "chair_leg",
				"name": "右後腳",
				"position": {
					"x": 103.249,
					"z": -103.249
				},
				"normal": {
					"y": 1
				},
				"angle": 145
			},
			{
				"type": "center_chair_leg",
				"name": "椅腳",
				"position": {
					"x": 0,
					"z": 0
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "arm_rest",
				"name": "右扶手",
				"position": {
					"x": 115
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			},
			{
				"type": "arm_rest",
				"name": "左扶手",
				"position": {
					"x": -115
				},
				"normal": {
					"y": 1
				},
				"angle": 180
			},
			{
				"type": "back_support",
				"name": "背部支撐",
				"position": {
					"z": -145
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			},
			{
				"id": "base",
				"material": "black_paint"
			},
			{
				"id": "surface",
				"material": "rattan_square"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 300,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 100,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square_black"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square_grey"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square_white"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "SE014",
		"name": "圓藤木座",
		"type": "seat",
		"price": 3000,
		"dimension": {
			"height": 30,
			"width": 400,
			"depth": 400
		},
		"model": "SE014",
		"junctions": [
			{
				"type": "chair_leg",
				"name": "右前腳",
				"position": {
					"x": 87.411,
					"z": 87.411
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "chair_leg",
				"name": "左前腳",
				"position": {
					"x": -87.411,
					"z": 87.411
				},
				"normal": {
					"y": 1
				},
				"angle": -45
			},
			{
				"type": "chair_leg",
				"name": "左後腳",
				"position": {
					"x": -87.411,
					"z": -87.411
				},
				"normal": {
					"y": 1
				},
				"angle": -145
			},
			{
				"type": "chair_leg",
				"name": "右後腳",
				"position": {
					"x": 87.411,
					"z": -87.411
				},
				"normal": {
					"y": 1
				},
				"angle": 145
			},
			{
				"type": "center_chair_leg",
				"name": "椅腳",
				"position": {
					"x": 0,
					"z": 0
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "arm_rest",
				"name": "右扶手",
				"position": {
					"x": 110
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			},
			{
				"type": "arm_rest",
				"name": "左扶手",
				"position": {
					"x": -110
				},
				"normal": {
					"y": 1
				},
				"angle": 180
			},
			{
				"type": "back_support",
				"name": "背部支撐",
				"position": {
					"z": -145
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			},
			{
				"id": "base",
				"material": "black_paint"
			},
			{
				"id": "surface",
				"material": "rattan_round"
			},
			{
				"id": "frame",
				"material": "white_oak"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 500,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round"
							},
							{
								"target": "parts.frame.material",
								"value": "white_oak"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 100,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round"
							},
							{
								"target": "parts.frame.material",
								"value": "white_oak"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round_black"
							},
							{
								"target": "parts.frame.material",
								"value": "black_paint"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round_grey"
							},
							{
								"target": "parts.frame.material",
								"value": "grey_paint"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round_white"
							},
							{
								"target": "parts.frame.material",
								"value": "white_paint"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "SE108",
		"name": "彎曲鋁座",
		"type": "seat",
		"price": 2200,
		"dimension": {
			"height": 30,
			"width": 370,
			"depth": 370
		},
		"model": "SE108",
		"junctions": [
			{
				"type": "chair_leg",
				"name": "右前腳",
				"position": {
					"x": 89.741,
					"z": 89.741
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "chair_leg",
				"name": "左前腳",
				"position": {
					"x": -89.741,
					"z": 89.741
				},
				"normal": {
					"y": 1
				},
				"angle": -45
			},
			{
				"type": "chair_leg",
				"name": "左後腳",
				"position": {
					"x": -89.741,
					"z": -89.741
				},
				"normal": {
					"y": 1
				},
				"angle": -145
			},
			{
				"type": "chair_leg",
				"name": "右後腳",
				"position": {
					"x": 89.741,
					"z": -89.741
				},
				"normal": {
					"y": 1
				},
				"angle": 145
			},
			{
				"type": "center_chair_leg",
				"name": "椅腳",
				"position": {
					"x": 0,
					"z": 0
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "arm_rest",
				"name": "右扶手",
				"position": {
					"x": 115
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			},
			{
				"type": "arm_rest",
				"name": "左扶手",
				"position": {
					"x": -115
				},
				"normal": {
					"y": 1
				},
				"angle": 180
			},
			{
				"type": "back_support",
				"name": "背部支撐",
				"position": {
					"z": -120
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "brushed_metal"
			}
		]
	},
	{
		"id": "CN005",
		"name": "學生木座",
		"type": "seat",
		"tag": [
			"combination"
		],
		"price": 4000,
		"dimension": {
			"height": 30,
			"width": 370,
			"depth": 370
		},
		"model": "CN005",
		"junctions": [
			{
				"type": "chair_leg",
				"name": "右前腳",
				"position": {
					"x": 96.249,
					"z": 96.249
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "chair_leg",
				"name": "左前腳",
				"position": {
					"x": -96.249,
					"z": 96.249
				},
				"normal": {
					"y": 1
				},
				"angle": -45
			},
			{
				"type": "chair_leg",
				"name": "左後腳",
				"position": {
					"x": -96.249,
					"z": -96.249
				},
				"normal": {
					"y": 1
				},
				"angle": -145
			},
			{
				"type": "chair_leg",
				"name": "右後腳",
				"position": {
					"x": 96.249,
					"z": -96.249
				},
				"normal": {
					"y": 1
				},
				"angle": 145
			},
			{
				"type": "center_chair_leg",
				"name": "椅腳",
				"position": {
					"x": 0,
					"z": 0
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "arm_rest",
				"name": "右扶手",
				"position": {
					"x": 110.213
				},
				"normal": {
					"y": 1
				},
				"angle": 0
			},
			{
				"type": "arm_rest",
				"name": "左扶手",
				"position": {
					"x": -110.213
				},
				"normal": {
					"y": 1
				},
				"angle": 180
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "walnut_horizontal"
			},
			{
				"id": "surface",
				"material": "walnut_horizontal"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 1300,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut_horizontal"
							},
							{
								"target": "parts.surface.material",
								"value": "walnut_horizontal"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 400,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak_horizontal"
							},
							{
								"target": "parts.surface.material",
								"value": "white_oak_horizontal"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "black_paint"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "grey_paint"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "white_paint"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "BR103",
		"name": "彎曲鋁背",
		"type": "back_rest",
		"price": 1800,
		"dimension": {
			"height": 27,
			"width": 300,
			"depth": 300
		},
		"model": "BR103",
		"parts": [
			{
				"id": "body",
				"material": "brushed_metal"
			}
		]
	},
	{
		"id": "BR302",
		"name": "圓形曲木背",
		"type": "back_rest",
		"price": 1800,
		"dimension": {
			"height": 52,
			"width": 300,
			"depth": 300
		},
		"model": "BR302",
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 200,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "BR306",
		"name": "方藤木背",
		"type": "back_rest",
		"price": 2800,
		"dimension": {
			"height": 30,
			"width": 300,
			"depth": 400
		},
		"model": "BR306",
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			},
			{
				"id": "surface",
				"material": "rattan_square"
			},
			{
				"id": "frame",
				"material": "white_oak"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 200,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square"
							},
							{
								"target": "parts.frame.material",
								"value": "white_oak"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 100,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square"
							},
							{
								"target": "parts.frame.material",
								"value": "white_oak"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square_black"
							},
							{
								"target": "parts.frame.material",
								"value": "black_paint"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square_grey"
							},
							{
								"target": "parts.frame.material",
								"value": "grey_paint"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_square_white"
							},
							{
								"target": "parts.frame.material",
								"value": "white_paint"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "BR307",
		"name": "圓藤木背",
		"type": "back_rest",
		"price": 2800,
		"dimension": {
			"height": 30,
			"width": 300,
			"depth": 300
		},
		"model": "BR307",
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			},
			{
				"id": "surface",
				"material": "rattan_round"
			},
			{
				"id": "frame",
				"material": "white_oak"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 300,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 100,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round_black"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round_grey"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							},
							{
								"target": "parts.surface.material",
								"value": "rattan_round_white"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "ST001",
		"name": "小圓木桌",
		"type": "table_top",
		"price": 4800,
		"dimension": {
			"height": 30,
			"width": 550,
			"depth": 550
		},
		"model": "ST001",
		"junctions": [
			{
				"type": "chair_leg",
				"name": "右前腳",
				"position": {
					"x": 87.71,
					"z": 87.71
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "chair_leg",
				"name": "左前腳",
				"position": {
					"x": -87.71,
					"z": 87.71
				},
				"normal": {
					"y": 1
				},
				"angle": -45
			},
			{
				"type": "chair_leg",
				"name": "左後腳",
				"position": {
					"x": -87.71,
					"z": -87.71
				},
				"normal": {
					"y": 1
				},
				"angle": -135
			},
			{
				"type": "chair_leg",
				"name": "右後腳",
				"position": {
					"x": 87.71,
					"z": -87.71
				},
				"normal": {
					"y": 1
				},
				"angle": 135
			},
			{
				"type": "center_chair_leg",
				"name": "椅腳",
				"position": {
					"x": 0,
					"z": 0
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 500,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "ST003",
		"name": "小方木桌",
		"type": "table_top",
		"price": 4700,
		"dimension": {
			"height": 30,
			"width": 450,
			"depth": 450
		},
		"model": "ST003",
		"junctions": [
			{
				"type": "chair_leg",
				"name": "右前腳",
				"position": {
					"x": 87.71,
					"z": 87.71
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			},
			{
				"type": "chair_leg",
				"name": "左前腳",
				"position": {
					"x": -87.71,
					"z": 87.71
				},
				"normal": {
					"y": 1
				},
				"angle": -45
			},
			{
				"type": "chair_leg",
				"name": "左後腳",
				"position": {
					"x": -87.71,
					"z": -87.71
				},
				"normal": {
					"y": 1
				},
				"angle": -135
			},
			{
				"type": "chair_leg",
				"name": "右後腳",
				"position": {
					"x": 87.71,
					"z": -87.71
				},
				"normal": {
					"y": 1
				},
				"angle": 135
			},
			{
				"type": "center_chair_leg",
				"name": "椅腳",
				"position": {
					"x": 0,
					"z": 0
				},
				"normal": {
					"y": 1
				},
				"angle": 45
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 400,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 100,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "CL001",
		"name": "棒球鐵腳",
		"type": "chair_leg",
		"price": 300,
		"model": "CL001",
		"parts": [
			{
				"id": "body",
				"material": "black_paint"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "black",
				"options": [
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_paint"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_paint"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_paint"
							}
						]
					},
					{
						"name": "鐵灰",
						"value": "dark_grey",
						"photo_url": "dark_grey_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "dark_grey_paint"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "CL004",
		"name": "哥德鐵腳",
		"type": "chair_leg",
		"price": 200,
		"model": "CL004",
		"parts": [
			{
				"id": "body",
				"material": "black_paint"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "black",
				"options": [
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_paint"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_paint"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_paint"
							}
						]
					},
					{
						"name": "鐵灰",
						"value": "dark_grey",
						"photo_url": "dark_grey_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "dark_grey_paint"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "CL005",
		"name": "魔法棒腳",
		"type": "chair_leg",
		"price": 300,
		"model": "CL005",
		"parts": [
			{
				"id": "body",
				"material": "black_paint"
			},
			{
				"id": "base",
				"material": "black_paint"
			},
			{
				"id": "leg_cover",
				"material": "brass"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "black",
				"options": [
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_paint"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_paint"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_paint"
							}
						]
					},
					{
						"name": "鐵灰",
						"value": "dark_grey",
						"photo_url": "dark_grey_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "dark_grey_paint"
							}
						]
					}
				]
			},
			{
				"id": "leg_cover",
				"name": "椅腳配件材質",
				"default": "brass",
				"options": [
					{
						"name": "紅銅",
						"value": "copper",
						"photo_url": "copper",
						"targets": [
							{
								"target": "parts.leg_cover.material",
								"value": "copper"
							}
						]
					},
					{
						"name": "黃銅",
						"value": "brass",
						"photo_url": "brass",
						"targets": [
							{
								"target": "parts.leg_cover.material",
								"value": "brass"
							}
						]
					},
					{
						"name": "胡桃木",
						"value": "walnut",
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.leg_cover.material",
								"value": "walnut"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.leg_cover.material",
								"value": "white_oak"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "CL008",
		"name": "羅馬柱木腳",
		"type": "chair_leg",
		"price": 1100,
		"model": "CL008",
		"parts": [
			{
				"id": "body",
				"material": "walnut_leg"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 200,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut_leg"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak_leg"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "CL009",
		"name": "羅馬殿堂木腳",
		"type": "chair_leg",
		"price": 900,
		"model": "CL009",
		"parts": [
			{
				"id": "body",
				"material": "walnut_leg"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 400,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut_leg"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 200,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak_leg"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "CL010",
		"name": "四方空木腳",
		"type": "chair_leg",
		"price": 800,
		"model": "CL010",
		"parts": [
			{
				"id": "body",
				"material": "walnut_leg"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 200,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut_leg"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 100,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak_leg"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "CL014",
		"name": "棒球木腳",
		"type": "chair_leg",
		"price": 700,
		"model": "CL014",
		"parts": [
			{
				"id": "body",
				"material": "walnut_leg"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 400,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut_leg"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 100,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak_leg"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "CL033",
		"name": "四方空鋁腳",
		"type": "chair_leg",
		"price": 1300,
		"model": "CL033",
		"parts": [
			{
				"id": "body",
				"material": "polishing"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		]
	},
	{
		"id": "CL037",
		"name": "羅馬殿堂鋁腳",
		"type": "chair_leg",
		"price": 1100,
		"model": "CL037",
		"parts": [
			{
				"id": "body",
				"material": "polishing"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		]
	},
	{
		"id": "CL002",
		"name": "水溝蓋圓盤腳",
		"type": "center_chair_leg",
		"tag": [
			"combination"
		],
		"price": 4300,
		"model": "CL002",
		"parts": [
			{
				"id": "body",
				"material": "black_paint"
			},
			{
				"id": "base",
				"material": "black_paint"
			},
			{
				"id": "ground_base",
				"material": "from_taiwan"
			}
		]
	},
	{
		"id": "BS106",
		"name": "方形椅背支撐",
		"type": "back_support",
		"price": 400,
		"model": "BS106",
		"junctions": [
			{
				"type": "back_rest",
				"name": "椅背",
				"position": {
					"y": 247.979,
					"z": -86.181
				},
				"normal": {
					"y": 0.1736482,
					"z": 0.9848078
				},
				"angle": 0
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "black_paint"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "black",
				"options": [
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_paint"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_paint"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_paint"
							}
						]
					},
					{
						"name": "鐵灰",
						"value": "dark_grey",
						"photo_url": "dark_grey_paint",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "dark_grey_paint"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "BS301",
		"name": "原木椅背支撐",
		"type": "back_support",
		"price": 1600,
		"model": "BS301",
		"junctions": [
			{
				"type": "back_rest",
				"name": "椅背",
				"position": {
					"y": 250.894,
					"z": -89.181
				},
				"normal": {
					"y": 0.1736482,
					"z": 0.9848078
				},
				"angle": 0
			}
		],
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"price": 300,
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"price": 100,
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							}
						]
					},
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "black_wood"
							}
						]
					},
					{
						"name": "灰",
						"value": "grey",
						"photo_url": "grey_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "grey_wood"
							}
						]
					},
					{
						"name": "白",
						"value": "white",
						"photo_url": "white_wood",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_wood"
							}
						]
					}
				]
			}
		]
	},
	{
		"id": "AR002",
		"name": "彎管木扶手",
		"type": "arm_rest",
		"price": 500,
		"model": "AR002",
		"parts": [
			{
				"id": "body",
				"material": "walnut"
			},
			{
				"id": "base",
				"material": "black_paint"
			}
		],
		"variations": [
			{
				"id": "body",
				"name": "材質",
				"default": "walnut",
				"options": [
					{
						"name": "胡桃木",
						"value": "walnut",
						"photo_url": "walnut",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "walnut"
							}
						]
					},
					{
						"name": "白橡木",
						"value": "white_oak",
						"photo_url": "white_oak",
						"targets": [
							{
								"target": "parts.body.material",
								"value": "white_oak"
							}
						]
					}
				]
			},
			{
				"id": "base",
				"name": "彎管材質",
				"default": "black",
				"options": [
					{
						"name": "黑",
						"value": "black",
						"photo_url": "black_paint",
						"targets": [
							{
								"target": "parts.base.material",
								"value": "black_paint"
							}
						]
					},
					{
						"name": "白",
						"value": "grey",
						"photo_url": "grey_paint",
						"targets": [
							{
								"target": "parts.base.material",
								"value": "grey_paint"
							}
						]
					}
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/components.json
// module id = 168
// module chunks = 5